import ImageParty from 'modules/components/ImageIcons/ImageParty';
import { memo } from 'react';

import { messages } from './SuccessPopup.messages';
import { ConfirmButton, ImageWrapper, Root, Title } from './SuccessPopup.styles';
import { SuccessPopupProps } from './SuccessPopup.types';

const SuccessPopup = memo<SuccessPopupProps>((props) => {
    const { closePopup } = props;

    return (
        <Root>
            <>
                <ImageWrapper>
                    <ImageParty />
                </ImageWrapper>

                <Title>{messages.title}</Title>

                <ConfirmButton execute={closePopup}>{messages.confirmButton}</ConfirmButton>
            </>
        </Root>
    );
});

export default SuccessPopup;
